export const REGEX = {
  ALL_BRACKETS: /[{()}]/g
};
